import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { LayoutComponent } from "../layout/layout.component";
import { EndorseNameAppNoResultComponent } from "./endorse-name-app-no-result.component";

const routes: Routes = [
  {
    path: 'dashboard',
    component: LayoutComponent,
    children: [
      {
        path: 'endorse-name-app-no-result',
        component: EndorseNameAppNoResultComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EndorseNameAppNoResultRoutingModule { }
